module.exports = __webpack_public_path__ + "img/anolis.b6498e3b.png";